import React from "react";
import { Trans, useTranslation} from 'react-i18next';
import './btoGalleryGarden.css'
import { Link } from "react-router-dom";


export default function BtogalleryGarden() {
    return (
        <Link style = {{textDecoration: "none"}} to="../gallerygard">
            <div className="btogcontainergar">
                <div className="textbtogcontainer">
                    <p className="buttontogtext"><Trans i18nKey="description.gotogallery"></Trans></p>
                </div>
            </div>
        </Link>
        );
}